<template>
    <div class="noop">
        <error :error="state.error" :method="state.method" :cardError="cardError && currentPaymentOption == 'card' ? cardError: '' " />
    </div>
</template>

<script>
import { injectStore, mapState } from "redux-vuex";
import { ref, onBeforeUnmount } from "vue";
import { getValueFromPath } from "@/support/helpers";
import Error from "@/components/common/payment-error";
export default {
    name: "PaymentSuccessful",
    components: {
        Error,
    },
    props: {
        shouldRender: {
            type: Boolean,
            default: true,
        },
    },
    setup() {
        const success = ref(null);
        const store = injectStore();
        const cardError = ref(null);
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        function setCardError(e){
            cardError.value = e;
        }
        onBeforeUnmount(() => {
            subscription();
        });
        return {
            state: mapState({
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                customer: (state) => getValueFromPath(state, "customer") || null,
                method: (state) => getValueFromPath(state, "method") || [],
                merchant: (state) => getValueFromPath(state, "merchant") || null,
                error: (state) => getValueFromPath(state, "error") || null,
            }),
            setCardError,
            cardError,
            success,
        };
    },
};
</script>

<style lang="scss" scoped>
.noop{
    display: flex;
    justify-content: center;
    padding-top: 2rem;
}
</style>